module.exports = __webpack_public_path__ + "static/media/languan.7ca3480f.gif";